module.exports = __webpack_public_path__ + "img/weibo.d4ca2626.jpg";